import { create } from "zustand";
import { fetchParametres, updateParametres as apiUpdateParametres, type DossierParametres } from "../lib/parametres";

const DEFAULTS: DossierParametres = {
  tvaActive: false,
  tauxTva: 18,
  anneeExercice: new Date().getFullYear(),
};

interface ParametresState {
  parametresByDossier: Record<string, DossierParametres>;
  getParametres: (dossierId: string | null) => DossierParametres;
  loadParametres: (dossierId: string) => Promise<void>;
  saveParametres: (dossierId: string, p: DossierParametres) => Promise<void>;
}

export const useParametresStore = create<ParametresState>((set, get) => ({
  parametresByDossier: {},

  getParametres: (dossierId) => {
    if (!dossierId) return DEFAULTS;
    return get().parametresByDossier[dossierId] ?? DEFAULTS;
  },

  loadParametres: async (dossierId) => {
    try {
      const p = await fetchParametres(dossierId);
      set((s) => ({
        parametresByDossier: { ...s.parametresByDossier, [dossierId]: p },
      }));
    } catch {
      set((s) => ({
        parametresByDossier: { ...s.parametresByDossier, [dossierId]: DEFAULTS },
      }));
    }
  },

  saveParametres: async (dossierId, p) => {
    await apiUpdateParametres(dossierId, p);
    set((s) => ({
      parametresByDossier: { ...s.parametresByDossier, [dossierId]: p },
    }));
  },
}));
